export default __webpack_public_path__ + "static/media/31.8ed75240.jpg";